import { useSyncExternalStore } from 'react';
import { getSortPreference, subscribeSortPreference } from '../lib/sortPreference';

export function useSortPreference() {
  return useSyncExternalStore(subscribeSortPreference, getSortPreference, getSortPreference);
}
